import { ELoginSource } from '@webtrader/core/api/user/types';
import request from '@webtrader/core/request';

export interface IDemoAttributionParams {
  pId?: string;
  afSub?: string;
  afKeyword?: string;
  afAdFormat?: string;
  clickId?: string;
}

export interface IDemoAccountCreationParams {
  firstName?: string;
  lastName?: string;
  email: string;
  phoneNumber: string;
  depositAmount?: number;
  country: string;
  loginSource?: ELoginSource;
  appsFlyerAttribute?: IDemoAttributionParams;
  marketingPageUrl?: string;
  language?: string;
}

export interface IDemoAccountCreationResponse {
  login: number;
  name: string;
  email: string;
  investorPassword: string;
  password: string;
  userGroup: string;
  deposit: number;
  leverage: number;
  currency: string;
  serverName: string;
  phoneNumber: string;
}

export default {
  demo: (params: IDemoAccountCreationParams) => {
    return request.post<IDemoAccountCreationResponse>('/api/user/v3/account/demo', params);
  },
  demoAuth: (params: IDemoAccountCreationParams) => {
    return request.post<IDemoAccountCreationResponse>('/api/user/v3/account/demo/auth', params);
  }
};
